module.exports = __webpack_public_path__ + "img/magic-stick-top.c63218a2.svg";